<template>
  <portal-layout>
    <div class="exam-page">
      <h2 class="page-title">在线考试</h2>
      <div v-loading="loading" class="exam-list">
        <div v-if="!loading && exams.length === 0" class="empty-tip">暂无考试安排</div>
        <div v-for="exam in exams" :key="exam.id" class="exam-card">
          <div class="exam-card-header">
            <h3 class="exam-name">{{ exam.examName }}</h3>
            <el-tag :type="statusTagType(exam.myStatus)" size="small">{{ statusText(exam.myStatus) }}</el-tag>
          </div>
          <p class="exam-desc">{{ exam.examDesc }}</p>
          <div class="exam-meta">
            <span><i class="el-icon-time"></i> {{ exam.startTime }} 至 {{ exam.endTime }}</span>
            <span v-if="exam.duration"><i class="el-icon-alarm-clock"></i> 限时 {{ formatDuration(exam.duration) }}</span>
            <span v-else><i class="el-icon-alarm-clock"></i> 不限时</span>
          </div>
          <div class="exam-card-footer">
            <span v-if="exam.myStatus === '2'" class="score-text">
              得分：<strong>{{ exam.myTotalScore }}</strong> 分
            </span>
            <span v-else class="score-text"></span>
            <div class="action-buttons">
              <el-button v-if="exam.myStatus === '0'" type="primary" size="small"
                         @click="beginExam(exam)">开始考试</el-button>
              <el-button v-if="exam.myStatus === '1'" type="warning" size="small"
                         @click="continueExam(exam)">继续答题</el-button>
              <el-button v-if="exam.myStatus === '2'" type="success" size="small" plain
                         @click="viewResult(exam)">查看成绩</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';
import storage from '@/common/storage.js';
export default {
  name: 'PortalCustomizeExamList',
  components: { PortalLayout },
  data() {
    return {
      loading: false,
      exams: []
    }
  },
  created() {
    this.queryExams();
  },
  methods: {
    queryExams() {
      this.loading = true;
      api.hoj_customize_exam_list().then((r) => {
        if (r.data.code === "200") {
          // 后端 R.ok(List) 把列表放在 rows 字段(data 为对象时才有值)，做兼容兜底
          this.exams = r.data.rows || r.data.data || [];
        }
      }).catch(() => {
        // 未登录(401)已由 common/api.js 统一跳转门户登录页，这里不重复提示
      }).finally(() => {
        this.loading = false;
      });
    },
    statusText(status) {
      const map = { '0': '未参加', '1': '进行中', '2': '已提交' };
      return map[status] || '未参加';
    },
    statusTagType(status) {
      const map = { '0': 'info', '1': 'warning', '2': 'success' };
      return map[status] || 'info';
    },
    formatDuration(seconds) {
      if (!seconds) return '-';
      let h = Math.floor(seconds / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      if (h > 0) return h + '小时' + (m > 0 ? m + '分钟' : '');
      return m + '分钟';
    },
    // 检查登录状态，未登录跳转登录页
    checkLogin() {
      if (!storage.getString('portalMember')) {
        if (this.$route.name === 'PortalLogin') return false;
        this.$router.push({ name: 'PortalLogin', query: { redirect: this.$route.fullPath } }).catch(() => {});
        return false;
      }
      return true;
    },
    beginExam(exam) {
      if (!this.checkLogin()) {
        return;
      }
      this.$confirm('开始考试后将自动计时，确认现在开始吗？', '提示', {
        confirmButtonText: '开始考试',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.hoj_customize_exam_begin({ eid: exam.id }).then((r) => {
          if (r.data.code === "200") {
            this.$router.push('/portal/customize/exam/answer?recordId=' + r.data.data.record.recordId).catch(() => {});
          } else {
            this.$message.error(r.data.msg || '开始考试失败');
          }
        }).catch(() => {
          // 未登录(401)已由 common/api.js 统一跳转门户登录页
        });
      }).catch(() => {});
    },
    continueExam(exam) {
      if (!this.checkLogin()) {
        return;
      }
      this.$router.push('/portal/customize/exam/answer?recordId=' + exam.myRecordId).catch(() => {});
    },
    viewResult(exam) {
      if (!this.checkLogin()) {
        return;
      }
      this.$router.push('/portal/customize/exam/answer?recordId=' + exam.myRecordId).catch(() => {});
    }
  }
};
</script>
<style scoped>
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0 0 25px 0;
}
.exam-list {
  min-height: 200px;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px;
}
.exam-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s;
}
.exam-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}
.exam-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.exam-name {
  font-size: 18px;
  color: #303133;
  margin: 0;
}
.exam-desc {
  font-size: 14px;
  color: #606266;
  margin: 0 0 15px 0;
  line-height: 1.6;
}
.exam-meta {
  display: flex;
  gap: 30px;
  font-size: 13px;
  color: #909399;
  margin-bottom: 18px;
}
.exam-card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}
.score-text {
  font-size: 14px;
  color: #606266;
}
.score-text strong {
  color: #F56C6C;
  font-size: 18px;
}
</style>
